import moment from "moment";

export const MAX_DOB_DATE = moment().subtract(18, "years").endOf("day");

export const formatDobInput = (value = "") => {
	const digits = `${value}`.replace(/\D/g, "").slice(0, 8);
	if (digits.length <= 2) return digits;
	if (digits.length <= 4) return `${digits.slice(0, 2)}/${digits.slice(2)}`;
	return `${digits.slice(0, 2)}/${digits.slice(2, 4)}/${digits.slice(4)}`;
};

export const parseDobInput = (value = "") => {
	const parsedDob = moment(value, "DD/MM/YYYY", true);
	if (!parsedDob.isValid()) return { error: "Please enter date of birth in DD/MM/YYYY format", value: null };
	if (parsedDob.isAfter(MAX_DOB_DATE)) return { error: "Date of birth must be at least 18 years ago", value: null };
	return { error: null, value: parsedDob.valueOf() };
};

